import { render } from "./update-competence-comment.vue?vue&type=template&id=0dcf7aa8&scoped=true"
import script from "./update-competence-comment.vue?vue&type=script&lang=js"
export * from "./update-competence-comment.vue?vue&type=script&lang=js"

import "./update-competence-comment.vue?vue&type=style&index=0&id=0dcf7aa8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dcf7aa8"],['__file',"src/components/applications/wagesetting/update/update-competence-comment.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0dcf7aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0dcf7aa8', __exports__)) {
    api.reload('0dcf7aa8', __exports__)
  }
  
  module.hot.accept("./update-competence-comment.vue?vue&type=template&id=0dcf7aa8&scoped=true", () => {
    api.rerender('0dcf7aa8', render)
  })

}


export default __exports__